'use client'

import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSun, faMoon } from '@fortawesome/free-solid-svg-icons';
import { trackEvent } from '@/components/utils/analytics';
import './sun-moon.css';

const STORAGE_KEY = 'darkModeCheckbox';

const getInitialLightMode = () => {
  if (typeof window === 'undefined') return false;
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'light') return true;
  if (stored === 'dark') return false;
  // No localStorage value — fall back to system preference
  return window.matchMedia('(prefers-color-scheme: light)').matches;
};

const SunMoon = () => {
  const [isLight, setIsLight] = useState(false);

  useEffect(() => {
    const initial = getInitialLightMode();
    setIsLight(initial);
    applyMode(initial);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const applyMode = (light) => {
    const body = document.body;
    if (light) {
      body.classList.remove('dark-mode');
    } else {
      body.classList.add('dark-mode');
    }
    const metaTheme = document.querySelector('meta[name="theme-color"]');
    if (metaTheme) {
      metaTheme.setAttribute('content', light ? '#c79d94' : '#462255');
    }
  };

  const toggle = (e) => {
    const light = e.target.checked;
    setIsLight(light);
    applyMode(light);
    localStorage.setItem(STORAGE_KEY, light ? 'light' : 'dark');
    trackEvent('toggle_dark_mode', { mode: light ? 'light' : 'dark' });
    document.dispatchEvent(new CustomEvent('colorModeChanged', {
      detail: light,
      bubbles: true,
      cancelable: true,
      composed: false,
    }));
  };

  return (
    <div className="sun-moon">
      <input
        type="checkbox"
        id="toggle--sunmoon"
        className="toggle--sunmoon"
        checked={isLight}
        onChange={toggle}
      />
      <label className="toggle--sunmoon-btn" htmlFor="toggle--sunmoon">
        <FontAwesomeIcon icon={isLight ? faSun : faMoon} />
      </label>
    </div>
  );
};

export default SunMoon;
